import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-242f120b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label-form" }
const _hoisted_2 = { class: "label-form" }
const _hoisted_3 = { class: "label-form" }
const _hoisted_4 = { class: "label-form" }
const _hoisted_5 = { class: "label-form" }


import { categoryService, productService, storeService } from "@/_services";
import {
  defineComponent,
  defineProps,
  defineEmits,
  ref,
  reactive,
  computed,
  onMounted,
  watch,
} from "vue";
import { useI18n } from "vue-i18n";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons-vue";
import { Rule } from "ant-design-vue/es/form";
import dayjs from "dayjs";

const __default__ = defineComponent({
  name: "LoyaltyPopup",
  components: {
    PlusOutlined,
    DeleteOutlined,
  },
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    open: { type: Boolean },
    store: {}
  },
  emits: [
  "closeLoyaltyPopup",
  "showSuccessNotification",
  "refreshStores",
  "loading",
],
  setup(__props: any, { emit: __emit }) {

const { t, locale } = useI18n();
const props = __props;

const openModal = computed(() => {
  return props.open;
});

const emit = __emit;

const closeLoyaltyPopup = () => {
  emit("closeLoyaltyPopup");
  form.quantityConsume = 0;
  form.quantityEarn = 0;
  form.type = "category";
  form.availability = [];
  dynamicRows.value = [
    {
      category: "",
    },
  ];
  form.rows = [...dynamicRows.value];
};

const state = reactive({
  types: [
    {
      label: t("Pos.Category"),
      value: "category",
    },
    {
      label: t("Pos.Product"),
      value: "product",
    },
  ],
  data: [] as any[],
});

const formRef = ref();
const form = reactive({
  quantityConsume: 0,
  quantityEarn: 0,
  type: "category",
  rows: [] as any[],
  availability: [] as any[],
});

const rules: Record<string, Rule[]> = {
  quantityConsume: [{ required: true, message: t("Pos.RequiredField") }],
  quantityEarn: [{ required: true, message: t("Pos.RequiredField") }],
  type: [{ required: true, message: t("Pos.RequiredField") }],
  "rows.0.category": [{ required: true, message: t("Pos.RequiredField") }],
  availability: [{ required: true, message: t("Pos.RequiredField") }],
};
const dynamicRows = ref([
  {
    category: "",
  },
]);

const textDirection = computed(() => {
  return locale.value === "ar" ? "rtl" : "ltr";
});

const loadingData = ref(false);

const getCategories = async () => {
  try {
    loadingData.value = true;
    const res = await categoryService.getAll();
    state.data = res.data;
  } catch (error) {
    console.log(error);
  } finally {
    loadingData.value = false;
  }
};

const getProducts = async () => {
  try {
    loadingData.value = true;
    const res = await productService.getAll();
    state.data = res.data;
  } catch (error) {
    console.log(error);
  } finally {
    loadingData.value = false;
  }
};

const handleType = async (value: string) => {
  if (value === "category") {
    await getCategories();
  } else {
    await getProducts();
  }
};

const handleQuantityConsumeChange = (value: number) => {
  while (dynamicRows.value.length > value) {
    dynamicRows.value.pop();
  }
  form.rows = [...dynamicRows.value];
};

const addRow = () => {
  // if (dynamicRows.value.length < form.quantityConsume) {
  dynamicRows.value.push({
    category: "",
  });
  form.rows = [...dynamicRows.value];
  // }
};

const removeRow = (index: number) => {
  if (dynamicRows.value.length > 1) {
    dynamicRows.value.splice(index, 1);
    form.rows = [...dynamicRows.value];
  }
};

const confirm = () => {
  formRef.value
    .validate()
    .then(async () => {
      try {
        emit("loading", true);

        let loyaltyConfig = {
          quantityConsume: form.quantityConsume,
          quantityEarn: form.quantityEarn,
          type: form.type,
          items: dynamicRows.value,
          availability: form.availability
            ? [
                form.availability[0].format("YYYY-MM-DD HH:mm"),
                form.availability[1].format("YYYY-MM-DD HH:mm"),
              ]
            : null,
        };

        // Safely parse the store config with fallbacks
        let currentConfig: any = {};
        try {
          currentConfig = props.store?.config ? JSON.parse(props.store.config) : {};
        } catch (error) {
          console.error('Error parsing store config:', error);
          currentConfig = {};
        }

        const config = {
          order_config: currentConfig.order_config || {},
          loyalty_config: loyaltyConfig,
        };

        const formData = new FormData();
        formData.append("name", props.store.name);
        formData.append("description", props.store.description);
        formData.append("address", props.store.address);
        formData.append("email", props.store.email);
        formData.append("phone", props.store.phone);
        formData.append("logo", props.store.logo);
        formData.append("account_id", props.store.account_id);
        formData.append("config", JSON.stringify(config));
        await storeService.modify(props.store.id, formData);

        emit("refreshStores");
        emit("loading", false);
        emit("showSuccessNotification", t("Pos.LoyaltyUpdatedSuccessfully"));
        closeLoyaltyPopup();
      } catch (error) {
        console.log("error update store", error);
        emit("loading", false);
      }
    })
    .catch((error: any) => {
      console.log(error);
      emit("loading", false);
      closeLoyaltyPopup();
    });
};

const clearLoyaltyConfig = async () => {
  try {
    emit("loading", true);

    // Get current store config
    const currentConfig = props.store?.config
      ? JSON.parse(props.store.config)
      : {};

    // Remove loyalty_config from the config
    delete currentConfig.loyalty_config;

    // Update the store with the modified config
    // const updatedStore = {
    //   ...props.store,
    //   config: JSON.stringify(currentConfig)
    // };

    const config = {
      order_config: JSON.parse(props.store.config).order_config,
      loyalty_config: {},
    };

    const formData = new FormData();
    formData.append("name", props.store.name);
    formData.append("description", props.store.description);
    formData.append("address", props.store.address);
    formData.append("email", props.store.email);
    formData.append("phone", props.store.phone);
    formData.append("logo", props.store.logo);
    formData.append("account_id", props.store.account_id);
    formData.append("config", JSON.stringify(config));
    await storeService.modify(props.store.id, formData);

    // Reset form
    form.quantityConsume = 0;
    form.quantityEarn = 0;
    form.type = "category";
    form.availability = [];
    dynamicRows.value = [
      {
        category: "",
      },
    ];

    emit("loading", false);
    closeLoyaltyPopup();
  } catch (error) {
    console.error("Error clearing loyalty config:", error);
    emit("loading", false);
  }
};

onMounted(async () => {
  await getCategories();
});

watch(
  () => props.store,
  (newStore) => {
    if (newStore && newStore.config) {
      console.log("newStore",newStore)
      try {
        const config = JSON.parse(newStore.config);
        if (config.loyalty_config) {
          const loyaltyConfig = config.loyalty_config;

          // Set form values
          form.quantityConsume = loyaltyConfig.quantityConsume;
          form.quantityEarn = loyaltyConfig.quantityEarn;
          form.type = loyaltyConfig.type;

          // Set availability dates if they exist
          if (loyaltyConfig.availability) {
            form.availability = [
              dayjs(loyaltyConfig.availability[0]),
              dayjs(loyaltyConfig.availability[1]),
            ];
          }

          // Set dynamic rows
          if (loyaltyConfig.items && Array.isArray(loyaltyConfig.items)) {
            dynamicRows.value = loyaltyConfig.items;
            form.rows = [...loyaltyConfig.items];
          }

          // Load the appropriate data based on type
          handleType(loyaltyConfig.type);
        }
      } catch (error) {
        console.error("Error parsing store config:", error);
      }
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    open: openModal.value,
    "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((openModal).value = $event)),
    onCancel: closeLoyaltyPopup,
    centered: ""
  }, {
    title: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_unref(t)("Pos.Loyalty")), 1)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "submit",
        type: "primary",
        onClick: confirm
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("Pos.Confirm")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_button, {
        key: "back",
        onClick: closeLoyaltyPopup
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("Pos.Cancel")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_button, {
        key: "clear",
        danger: "",
        onClick: clearLoyaltyConfig
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("Pos.ClearLoyalty")), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref_key: "formRef",
        ref: formRef,
        model: form,
        rules: rules,
        layout: "vertical",
        class: _normalizeClass({ 'is-rtl': textDirection.value === 'rtl' })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { name: "type" }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)("Pos.Type")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: form.type,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.type) = $event)),
                        options: state.types,
                        onChange: handleType
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { gutter: 16 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { name: "quantityConsume" }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)("Pos.quantityConsume")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: form.quantityConsume,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.quantityConsume) = $event)),
                        type: "number",
                        min: "0",
                        onChange: handleQuantityConsumeChange
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { name: "quantityEarn" }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)("Pos.quantityEarn")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: form.quantityEarn,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.quantityEarn) = $event)),
                        type: "number",
                        min: "0"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { name: "availability" }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)("Pos.Availability")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_range_picker, {
                        class: "input-form",
                        value: form.availability,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.availability) = $event)),
                        "show-time": { format: 'HH:mm' },
                        format: "YYYY-MM-DD HH:mm",
                        placeholder: [_unref(t)('Pos.startDate'), _unref(t)('Pos.endDate')],
                        disabledDate: 
                (current) => current && current < _unref(dayjs)().startOf('day')
              
                      }, null, 8, ["value", "placeholder", "disabledDate"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dynamicRows.value, (row, index) => {
            return (_openBlock(), _createBlock(_component_a_row, {
              key: index,
              gutter: 16,
              class: "mb-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      name: ['rows', index, 'category'],
                      rules: [{ required: true, message: _unref(t)('Pos.RequiredField') }]
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)("Pos.Type")), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: row.category,
                          "onUpdate:value": ($event: any) => ((row.category) = $event),
                          options: 
                state.data.map((item) => ({ label: item.name, value: item.id }))
              
                        }, null, 8, ["value", "onUpdate:value", "options"])
                      ]),
                      _: 2
                    }, 1032, ["name", "rules"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_a_col, {
                  span: 4,
                  class: "action-container"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: addRow
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_unref(PlusOutlined))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      danger: "",
                      onClick: ($event: any) => (removeRow(index)),
                      disabled: dynamicRows.value.length <= 1
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_unref(DeleteOutlined))
                      ]),
                      _: 2
                    }, 1032, ["onClick", "disabled"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["model", "class"])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})